module.exports = __webpack_public_path__ + "static/samloyd.io-e68dbc6b532d5e7cca243e08a4af23cd.png";